import React from 'react'

const OnTitle = ({ block }) => {
    return (
        block?.content && (
            <div class="baseocom-sur-titre">
                <p>{block?.content}</p>
            </div>
        )
    )
}

export default OnTitle
